import React from "react";

const Auth = ({ children, type }) => {
  return <div>{children}</div>;
};

export default Auth;
